// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"207":"cddd6442","453":"51d25b02","489":"a6df1b7a","543":"faeff8d8","572":"0d22492e","629":"3cbc8a5a","682":"d58229d1","715":"85aae4eb","762":"7bb037b5","818":"7c0a4b2e","820":"96983b12"}[chunkId] + ".chunk.js";
};